import { type HandleProps, Position } from '@xyflow/react';

import { colors } from 'common';

import { EdgeHandleType } from '../../../../../types';
import { type BaseReactFlowBlockNodeProps } from '../types';

/**
 * This counteracts the node border width so that the handle is centered on the border.
 */
export const NODE_HANDLE_POSITION_STYLES = {
  [Position.Top]: { top: 0 },
  [Position.Left]: { left: -1 },
  [Position.Right]: { right: -1 },
  [Position.Bottom]: { bottom: 0 },
};

export type NodeHandleProps = Omit<HandleProps, 'isConnectable'> & {
  edgeHandleType: EdgeHandleType;
  nodeProps: BaseReactFlowBlockNodeProps;
};

export const EdgeHandleTypeToColor: Record<EdgeHandleType, string> = {
  [EdgeHandleType.Default]: colors.extended.blue[60],
  [EdgeHandleType.Error]: colors.extended.red[60],
};
